export const monitorLocale = {
  en: {
    region_title: 'Monitor Method',
    market_title: 'Monitor Method',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Monitor Method',
    button_market: 'Monitor Method',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    region_title: '监控方式',
    market_title: '监控方式',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '监控方式',
    button_market: '监控方式',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};
